import { useEffect, useRef } from 'react'

type TrackingEvent = 'SIGNUP' | 'PROGRAMENROLLMENT'

type MarketingPixelTrackingProps = {
  event: TrackingEvent
  subid?: string
  subid2?: string
  subid3?: string
  price?: string
}

export default function MarketingPixelTracking(
  props: MarketingPixelTrackingProps,
) {
  const hasRun = useRef(false)

  useEffect(() => {
    if (hasRun.current) {
      return
    }
    hasRun.current = true

    try {
      // Create and fire the main tracking pixel
      const pixel = document.createElement('img')
      pixel.src =
        `https://trk.osdrtb.net/u?c=8ce645c5-31df-41d5-aec2-7e567bee1fd3&ev=${props.event}` +
        (props.subid ? `&subid=${encodeURIComponent(props.subid)}` : '') +
        (props.subid2 ? `&subid2=${encodeURIComponent(props.subid2)}` : '') +
        (props.subid3 ? `&subid3=${encodeURIComponent(props.subid3)}` : '') +
        (props.price ? `&p=${encodeURIComponent(props.price)}` : '') +
        `&osrnd=${Math.round(new Date().getTime())}`

      pixel.setAttribute('referrerpolicy', 'no-referrer-when-downgrade')
      pixel.style.width = '1px'
      pixel.style.height = '1px'
      pixel.style.border = 'none'
      document.body.appendChild(pixel)

      // Add Amazon DSP tracking
      if (!window.amzn) {
        const script = document.createElement('script')
        script.src = 'https://c.amazon-adsystem.com/aat/amzn.js'
        script.id = 'amzn-pixel'
        script.async = true
        document.head.appendChild(script)

        script.onload = () => {
          if (window.amzn) {
            window.amzn('setRegion', 'NA')
            window.amzn('addTag', '6dcb7703-4b68-4ec5-acb5-c1952a7a8778')
            window.amzn('trackEvent', 'PageView')
          }
        }
      }
    } catch (e) {
      console.warn('Marketing pixel tracking failed:', e)
    }
  }, [props.event, props.subid, props.subid2, props.subid3, props.price])

  // Render fallback tracking pixels
  const trackingImages = []

  if (props.event === 'SIGNUP') {
    trackingImages.push(
      <img
        key="ttd-signup"
        height="1"
        width="1"
        style={{ borderStyle: 'none' }}
        alt=""
        src="https://insight.adsrvr.org/track/pxl/?adv=ksa3qmn&ct=0:r2fnrdd&fmt=3"
      />,
    )
  } else if (props.event === 'PROGRAMENROLLMENT') {
    trackingImages.push(
      <img
        key="ttd-enrollment"
        height="1"
        width="1"
        style={{ borderStyle: 'none' }}
        alt=""
        src="https://insight.adsrvr.org/track/pxl/?adv=ksa3qmn&ct=0:u7d0xpl&fmt=3"
      />,
    )
  }

  return <>{trackingImages}</>
}

// Add window type declarations
declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    amzn?: any
  }
}
